<div class="w-full bg-white border-box" style="border-radius: 10px;" id="election-employer">
  <div class="p-30" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Représentant de l'employeur</p>
        <p class="no-margin dark-gray text-sm">Personne habilitée à signer le protocole</p>
      </div>
    </div>
  </div>

  <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" id="employer-grid" class="p-30">
    <div>
      <p class="dark-blue no-margin">Civilité <span class="red">*</span></p>
      <div class="flex gap-10">
        <label class="flex align-items-center gap-5 pointer dark-blue">
          <input type="radio" name="employerGender" [value]="true" [(ngModel)]="employer.man"> Monsieur
        </label>
        <label class="flex align-items-center gap-5 pointer dark-blue">
          <input type="radio" name="employerGender" [value]="false" [(ngModel)]="employer.man"> Madame
        </label>
      </div>
    </div>

    <div></div>

    <div>
      <p class="dark-blue no-margin">Nom <span class="red">*</span></p>
      <input [(ngModel)]="employer.name" (ngModelChange)="onEmployerChange()" type="text" name="name" id="name"
        class="w-full text-md dark-blue pap-input" value="{{employer.name}}">
    </div>

    <div>
      <p class="dark-blue no-margin">Prénom <span class="red">*</span></p>
      <input [(ngModel)]="employer.firstName" (ngModelChange)="onEmployerChange()" type="text" name="firstName"
        id="firstName" class="w-full text-md dark-blue pap-input" value="{{employer.firstName}}">
    </div>

    <div style="grid-column: 1 / -1;">
      <p class="dark-blue no-margin">Fonction <span class="red">*</span></p>
      <input [(ngModel)]="employer.role" (ngModelChange)="onEmployerChange()" type="text" name="role" id="role"
        class="w-full text-md dark-blue pap-input" value="{{employer.role}}">
    </div>

  </div>
</div>